"use strict";
/**
 * Domain Events for Manulife Insurance Domain.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IllustrationGeneratedEvent = exports.PremiumCalculatedEvent = exports.PolicyCreatedEvent = void 0;
const base_1 = require("./base");
class PolicyCreatedEvent extends base_1.BaseDomainEvent {
    policyId;
    customerId;
    productCode;
    constructor(policyId, customerId, productCode) {
        super();
        this.policyId = policyId;
        this.customerId = customerId;
        this.productCode = productCode;
    }
}
exports.PolicyCreatedEvent = PolicyCreatedEvent;
class PremiumCalculatedEvent extends base_1.BaseDomainEvent {
    policyId;
    totalAnnualPremium;
    constructor(policyId, totalAnnualPremium) {
        super();
        this.policyId = policyId;
        this.totalAnnualPremium = totalAnnualPremium;
    }
}
exports.PremiumCalculatedEvent = PremiumCalculatedEvent;
class IllustrationGeneratedEvent extends base_1.BaseDomainEvent {
    policyId;
    projectedYears;
    constructor(policyId, projectedYears) {
        super();
        this.policyId = policyId;
        this.projectedYears = projectedYears;
    }
}
exports.IllustrationGeneratedEvent = IllustrationGeneratedEvent;
